function ReportContainer(options) {
  const AD_HOC_VALUE = 0,
    JS_DATEPICKER_CLASS = 'js-datepicker',
    JS_ADHOC_COMBOBOX_CLASS = 'js-adhoc-combobox',
    JS_TIMERANGE_DATEPICKER_CLASS = 'js-timerange-datepicker',
    dateRegex = new RegExp(/^\d{1,2}[\/]\d{1,2}[\/]\d{4}$/),
    repContainer = this;

  let runReportDisabled = false,
      isPeriodCorrect = false;

  this.element = document.getElementById(options.id);
  this.$element = $(this.element);
  this.$table = this.$element.find('table');
  this.runReportBtn = this.element.querySelector('.run-report');
  this.saveReportBtn = this.element.querySelector('.save-report');

  options.comboboxes = options.comboboxes || {};
  options.timerangeComboboxes = options.timerangeComboboxes || {};
  options.datepickers = options.datepickers || {};

  this.getDatepickers = () => {
    return repContainer.element.querySelectorAll(`.${JS_DATEPICKER_CLASS}`);
  };

  this.getAdHocComboboxes = () => {
    return repContainer.$element.find(`.${JS_ADHOC_COMBOBOX_CLASS}`);
  };

  this.getTimerangeDatepickers = () => {
    return repContainer.$element.find(`.${JS_TIMERANGE_DATEPICKER_CLASS}`);
  };

  this.getDatepeakerStartField = fieldName => {
    return repContainer.$element.find(`[name=${fieldName}_start]`);
  };

  this.getDatepeakerEndField = fieldName => {
    return repContainer.$element.find(`[name=${fieldName}_end]`);
  };

  this.assignOnDatetimeKeypress = () => {
    repContainer.getDatepickers().forEach(datepicker => {
      datepicker.addEventListener('keypress', e => {
        if (e.key === '/'){
          const slashCount = datepicker.value.match(/\//g);
          if (slashCount && slashCount.length === 2){
            e.preventDefault();
          }
        }
      });
    });
  };

  this.assignOnAdHocComboboxChange = () => {
    repContainer.getAdHocComboboxes().change(() => {
      if (repContainer.saveReportBtn) {
        repContainer.saveReportBtn.classList.remove('disabled');
      }
      $.each(options.timerangeComboboxes, fieldName => {
        const field = repContainer.$element.find(`[name=rel_${fieldName}]`),
          dtStartField = repContainer.getDatepeakerStartField(fieldName),
          dtEndField = repContainer.getDatepeakerEndField(fieldName),
          adHocSelected = field.val() == AD_HOC_VALUE;

        if (adHocSelected) {
          if (!dtStartField.is(':visible') || !dtEndField.is(':visible')){
            dtStartField.parent().show();
            dtEndField.parent().show();
          }
          runReportDisabled = !isPeriodCorrect;
          if (repContainer.saveReportBtn) {
            repContainer.saveReportBtn.classList.add('disabled');
          }
        } else {
          dtStartField.parent().hide().val();
          dtEndField.parent().hide().val();
          runReportDisabled = false;
        }
      });

      if(runReportDisabled) {
        repContainer.runReportBtn.classList.add('disabled');
      } else {
        repContainer.runReportBtn.classList.remove('disabled');
      }
    });
  };

  this.assignOnTimerangeDatepickerChange = () => {
    repContainer.getTimerangeDatepickers().change(() => {
      runReportDisabled = false;
      $.each(options.timerangeComboboxes, fieldName => {
        const startDt = repContainer.getDatepeakerStartField(fieldName),
          startTime = startDt.val(),
          endDt = repContainer.getDatepeakerEndField(fieldName),
          endTime = endDt.val();

        isPeriodCorrect = ((dateRegex.test(startTime) && dateRegex.test(endTime) &&
          (new Date(startTime) <= new Date(endTime))) ||
          (!startDt.is(':visible') && !endDt.is(':visible')));
        runReportDisabled = (runReportDisabled || !isPeriodCorrect);
      });

      if (runReportDisabled) {
        repContainer.runReportBtn.classList.add('disabled');
      } else {
        repContainer.runReportBtn.classList.remove('disabled');
      }
    });
  };

  this.assignOnCalendarClick = () => {
    repContainer.$element.find('.input-group-append').click(function(){
      $(this).parents('.input-group').find('.form-control').focus();
    })
  };

  this.assignOnClickRunReport = () => {
    if (repContainer.runReportBtn) {
      repContainer.runReportBtn.addEventListener('click', () => {
        repContainer.$table.dataTable().fnDraw();
      });
    }

    return repContainer;
  };

  this.assignOnClickFilterButton = () => {
    const filterButton = repContainer.element.querySelector('.search-collapser');
    if (filterButton) {
      const $searchContainer = repContainer.$element.find('.search-container');
      filterButton.addEventListener('click', () => {
        $searchContainer.toggle();
      });
    }

    return repContainer;
  };

  this.assignOnClickDownloadButton = () => {
    const downloadButton = repContainer.element.querySelector('.js-download');
    if (downloadButton){
      downloadButton.addEventListener('click', () => {
        const a = document.createElement('a');
        a.href = encodeURI(options.getDownloadUrl());
        a.setAttribute('download', '');
        document.body.append(a);
        a.click();
        a.remove();
      });
    }

    return repContainer;
  };

  this.assignOnClickSaveReportButton = () => {
    const saveReportButton = repContainer.element.querySelector('.save-report');
    if (saveReportButton){
      saveReportButton.addEventListener('click', () => {
        save_report_definition(JSON.stringify(options.saveReport.getQuery()), options.saveReport.type);
      });
    }

    return repContainer;
  };

  this.buildDatepicker = (selector, params) => {
    return repContainer.$element.find(selector)
        .datepicker(params)
        .addClass(JS_DATEPICKER_CLASS);
  };
  this.buildCombobox = (selector, params) => {
    return repContainer.$element.find(selector).combobox(params);
  };
  this.buildAdHocCombobox = (selector, params) => {
    return repContainer.buildCombobox(selector, params).addClass(JS_ADHOC_COMBOBOX_CLASS);
  };

  this.buildTimerangeDatepicker = (selector, params) => {
    repContainer.buildDatepicker(selector, params).addClass(JS_TIMERANGE_DATEPICKER_CLASS);
  };

  this.buildComboboxes = () => {
    for (let key in options.comboboxes) {
      repContainer.buildCombobox(`[name=${key}]`, options.comboboxes[key].combobox || {});
    }

    return repContainer;
  };

  this.buildAdHocComboboxes = () => {
    for (let key in options.timerangeComboboxes) {
      const fieldSelector = `[name=rel_${key}]`,
          dtStartFieldSelector = `[name=${key}_start]`,
          dtEndFieldSelector = `[name=${key}_end]`;

      const opts = options.timerangeComboboxes[key];
      repContainer.buildAdHocCombobox(fieldSelector, opts.combobox || {});
      repContainer.buildTimerangeDatepicker(dtStartFieldSelector, opts.datepicker_start || {});
      repContainer.buildTimerangeDatepicker(dtEndFieldSelector, opts.datepicker_end || {});
    }

    return repContainer;
  };

  this.buildDatepickers = () => {
    for (let key in options.datepickers) {
      repContainer.buildDatepicker(`[name=${key}]`, options.datepickers[key].datepicker || {});
    }

    return repContainer;
  };

  this.buildReportSearchBody =  () => {
    repContainer.$element.find('.report_search_title').click(() => {
      if (repContainer.$element.find('.report_search_body:visible').length > 0){
        //it's visible. need to hide
        repContainer.$element.find('.report_search_body').slideUp();
        repContainer.$element.find('.search_collapser').removeClass('collapser_open').addClass('collapser_closed');
      }
      else {
        repContainer.$element.find('.report_search_body').slideDown();
        repContainer.$element.find('.search_collapser').removeClass('collapser_closed').addClass('collapser_open');
      }
    });
  };

  this.initializeActiveCombobox = filterDepends => {
    const reloadFilters = function() {
      const selected_id = this.value;
      if (selected_id == 0) {
        repContainer.$element.find('select[name=appliance_id] option').show().removeAttr('disabled');
        repContainer.$element.find('select[name=vault_id] option').show().removeAttr('disabled');
        if (this.name === 'reseller_id') {
          repContainer.$element.find('select[name=client_id] option').show().removeAttr('disabled');
          const client_id = repContainer.$element.find('select[name=client_id]').val();
          if (client_id != 0) {
            repContainer.$element.find(`select[name=appliance_id] option[data-client_id!=${client_id}]`).hide().attr('disabled', 'true');
          }
        } else {
          const reseller_id = repContainer.$element.find('select[name=reseller_id]').val();
          if ((typeof reseller_id !== 'undefined') && reseller_id != 0) {
            repContainer.$element.find(`select[name=appliance_id] option[data-reseller_id!=${reseller_id}]`).hide().attr('disabled', 'true');
          }
        }
      } else {
        if (this.name === 'reseller_id') {
          repContainer.$element.find('select[name=client_id] option').hide().attr('disabled', 'true');
          repContainer.$element.find(`select[name=client_id] option[data-reseller_id=${selected_id}]`).show().removeAttr('disabled');
          repContainer.$element.find('select[name=appliance_id] option').hide().attr('disabled', 'true');
          repContainer.$element.find(`select[name=appliance_id] option[data-reseller_id=${selected_id}]`).show().removeAttr('disabled');
          repContainer.$element.find('select[name=vault_id] option').hide().attr('disabled', 'true');
          repContainer.$element.find(`select[name=vault_id] option[data-reseller_id=${selected_id}]`).show().removeAttr('disabled');
        } else {
          repContainer.$element.find('select[name=appliance_id] option').hide().attr('disabled', 'true');
          repContainer.$element.find(`select[name=appliance_id] option[data-client_id=${selected_id}]`).show().removeAttr('disabled');
        }
      }
      repContainer.$element.find('select[name=appliance_id] option[data-client_id=0]').show().removeAttr('disabled');
      repContainer.$element.find('select[name=vault_id] option[data-reseller_id=0]').show().removeAttr('disabled');
      repContainer.$element.find('select[name=client_id] option[data-reseller_id=0]').show().removeAttr('disabled');
      if (this.name === 'reseller_id') {
        repContainer.$element.find('select[name=client_id]').combobox('refresh');
        repContainer.$element.find(' select[name=vault_id]').combobox('refresh');
      }
      repContainer.$element.find('select[name=appliance_id]').combobox('refresh');
    };
    const reloadFiltersWithDepends = function() {
      const filterValues = {};
      filterValues[this.name] = this.value;
      for (let filter in filterDepends) {
        if (filterDepends[filter].indexOf(this.name) !== -1) {
          const selectSelector =`select[name=${filter}]`;
          const $select = repContainer.$element.find(selectSelector);
          let fullSelector = `${selectSelector} option`,
              zeroSelector = fullSelector;
          filterDepends[filter].forEach(filterDependency => {
            if (!(filterDependency in filterValues)) {
              const $filterField = repContainer.$element.find(`select[name=${filterDependency}]`);
              filterValues[filterDependency] = $filterField ? $filterField.val() : 0;
            }
            if (filterValues[filterDependency] && filterValues[filterDependency] !== '0') {
              fullSelector += `[data-${filterDependency}~=${filterValues[filterDependency]}]`;
            }
            zeroSelector += `[data-${filterDependency }=0]`;
          });

          $select.find('option').hide().attr('disabled', 'true');
          repContainer.$element.find(fullSelector).show().removeAttr('disabled');
          repContainer.$element.find(zeroSelector).show().removeAttr('disabled');
          if ($select.val() === null) {
            $select.val('0');
          }
          $select.combobox('refresh');
        }
      }
    };

    if (filterDepends) {
      for (let filter in filterDepends) {
        filterDepends[filter].forEach(filterDependency => {
          const filterSelect = repContainer.element.querySelector(`[name=${filterDependency}]`);
          if (filterSelect) {
            filterSelect.onchange = reloadFiltersWithDepends;
          }
        });
      }
    } else {
      repContainer.element.querySelectorAll('[name=reseller_id], [name=client_id]').forEach(select => {
        select.onchange = reloadFilters;
      });
    }

    return repContainer;
  };

  this.buildTable = () => {
    let tableOptions = {
      bServerSide: true,
      iDeferLoading: 0,
      bFilter: false,
      bProcessing: true,
      sAjaxSource: options.table.ajaxSource,
      bJQueryUI: true,
      bStateSave: true,
      sPaginationType: 'full_numbers',
      pageLength: $.cookie('report_records_shown') || 10,
      autoWidth: false,
      columnDefs: [{
        width : 'auto',
        targets: '_all'
      }],
      fnServerData: (sSource, aoData, fnCallback) => {
        $.ajax({
          dataType: 'json',
          type: 'POST',
          url: sSource,
          data: options.table.fillServerData(aoData),
          success: fnCallback
        });
      },
      fnDrawCallback: () => {
        repContainer.$table.trigger('draw');
      },
      createdRow: (row, data, dataIndex, cells) => {
        row.classList.add('trow');
        for (let i = 0; i < cells.length; i++) {
          cells[i].classList.add('multiline');
        }
      }
    };

    if (options.table.options) {
      tableOptions = Object.assign(tableOptions, options.table.options);
    }

    repContainer.$table.dataTable(tableOptions);

    return  repContainer;
  };

  this.build = () => {
    repContainer.buildComboboxes();
    repContainer.buildAdHocComboboxes();
    repContainer.buildTable();
    repContainer.buildReportSearchBody();

    repContainer.assignOnDatetimeKeypress();
    repContainer.assignOnAdHocComboboxChange();
    repContainer.assignOnTimerangeDatepickerChange();
    repContainer.assignOnCalendarClick();
    repContainer.assignOnClickFilterButton();
    repContainer.assignOnClickRunReport();
    repContainer.assignOnClickDownloadButton();
    repContainer.assignOnClickSaveReportButton();
  };
}
